import React, { useEffect, useState } from "react";
import {
  Grid,
  Card,
  Text,
  Image,
  Skeleton,
  Button,
  Badge,
  CopyButton,
  Box,
  Alert,
} from "@mantine/core";
import { useClipboard } from "@mantine/hooks";
import { IconCopy, IconClipboardCheck, IconAlertCircle } from "@tabler/icons";
import { useParams, useNavigate } from "react-router-dom";
import { apiWithInterceptor } from "../../../../api";
import * as dayjs from "dayjs";
import { showNotification } from "@mantine/notifications";
import { openConfirmModal, closeAllModals } from "@mantine/modals";
export default function SessionsViewer() {
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const [sessions, setSessions] = useState([]);
  const [eventId, setEventId] = useState();
  const [deleteFlag, setDelete] = useState(false);
  const navigate = useNavigate();

  const clipboard = useClipboard({ timeout: 500 });
  const generateScanner = (id) => {
    apiWithInterceptor
      .post(`/session/${id}/generate-token`, {
        expiration_hours: 72,
      })
      .then((res) => {
        clipboard.copy(`http://ticketin.net/scan/?t=${res.data.token}`);
      });
  };

  useEffect(() => {
    setLoading(true);
    apiWithInterceptor
      .get(`/event/${id}?relations[]=sessions`)
      .then(function (response) {
        setSessions(response.data.sessions);
        setEventId(response.data.id);
        setLoading(false);
        setDelete(false);
      })

      .catch(function (error) {
        setLoading(false);
        showNotification({
          title: "Something went wrong",
          message: ` ${error?.response?.data?.message}`,
          color: "red",
        });
      });
  }, [deleteFlag]);
  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "1000px",
        margin: "auto",
      }}
    >
      <Grid
        sx={{
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
          flexDirection: "row",
        }}
        xs={12}
      >
        {loading ? (
          <Skeleton sx={{ height: "300px" }} />
        ) : sessions.length > 0 ? (
          sessions.map((item) => {
            return (
              <Grid.Col key={item.id} span={12}>
                <Card sx={{ height: "50%" }} shadow="sm" withBorder={true}>
                  <Card.Section withBorder>
                    <Image
                      height={250}
                      withPlaceholder
                      src={`https://api.ticketin.net/session/${item?.cover_image}`}
                      fit="cover"
                    />
                  </Card.Section>
                  <Grid>
                    <Grid.Col xs={12} sm={8} lg={8}>
                      <Card.Section
                        sx={{
                          margin: "5px",
                          paddingTop: "10px",
                        }}
                      >
                        <Text>
                          Session name:{" "}
                          <Text weight={700} span>
                            {item.name}
                          </Text>
                        </Text>
                        <Text>
                          Description:{" "}
                          <Text weight={700} span>
                            {item.description}
                          </Text>
                        </Text>
                        <Text>
                          Total tickets:{" "}
                          <Text weight={700} span>
                            {item.total_tickets}
                          </Text>
                        </Text>
                        <Text>
                          Created at:&nbsp;
                          <Text weight={700} span>
                            {dayjs(item.created_at).format("YYYY-MM-DD")}
                          </Text>
                        </Text>
                        <Text>
                          Start Date:&nbsp;
                          <Text weight={700} span>
                            {dayjs(item.start_date).format("YYYY-MM-DD")}
                          </Text>
                        </Text>
                        <Text>
                          End Date:&nbsp;
                          <Text weight={700} span>
                            {dayjs(item.end_date).format("YYYY-MM-DD")}
                          </Text>
                        </Text>
                      </Card.Section>
                    </Grid.Col>

                    <Grid.Col xs={12} sm={4} lg={4}>
                      <Card.Section
                        sx={{
                          margin: "5px",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Badge
                          variant="dot"
                          mb={15}
                          mt={15}
                          color={item.disabled ? "red" : "yellow"}
                        >
                          {item.disabled
                            ? "Disabled Session"
                            : "Active Session"}
                        </Badge>
                        <Button
                          compact
                          variant="filled"
                          sx={{ width: "150px", marginTop: "5px" }}
                          onClick={() => {
                            navigate(
                              `/app/events/create-session/editsession/${item.id}`,
                              {
                                state: {
                                  name: item.name,
                                  description: item.description,
                                  id: eventId,
                                  session: item,
                                },
                              }
                            );
                          }}
                        >
                          Edit session
                        </Button>
                        <Button
                          compact
                          variant="filled"
                          sx={{ width: "150px", marginTop: "5px" }}
                          onClick={() => {
                            navigate(`/app/events/answers`, {
                              state: {
                                sessionID: item.id,
                                sessionName: item.name,
                                formID: item.form_id,
                                eventID: eventId,
                              },
                            });
                          }}
                        >
                          View Answers
                        </Button>
                        <CopyButton
                          value={`https://apply.ticketin.net/form/${item.id}`}
                        >
                          {({ copied, copy }) => (
                            <Button
                              sx={{ width: "150px", marginTop: "5px" }}
                              variant="filled"
                              compact
                              onClick={copy}
                              rightIcon={
                                copied === false ? (
                                  <IconCopy size={15} />
                                ) : (
                                  <IconClipboardCheck size={15} />
                                )
                              }
                            >
                              {copied ? "Copied" : "Copy url"}
                            </Button>
                          )}
                        </CopyButton>

                        <Button
                          sx={{ width: "150px", marginTop: "5px" }}
                          variant="filled"
                          compact
                          onClick={() =>
                            openConfirmModal({
                              title: "Please confirm your action",
                              closeOnConfirm: false,
                              labels: {
                                confirm: "I'm sure",
                                cancel: "Cancel",
                              },
                              children: (
                                <Alert
                                  icon={<IconAlertCircle size={16} />}
                                  title="Alert!"
                                  color="red"
                                >
                                  This action will clear the previously used
                                  scanner token and disable the link
                                  permanently. Be sure the session is not active
                                  and the scanner link is not in use.
                                </Alert>
                              ),
                              onConfirm: () =>
                                openConfirmModal({
                                  title: "Duble check please",
                                  labels: {
                                    confirm: "Confirm",
                                    cancel: "Back",
                                  },
                                  closeOnConfirm: false,
                                  children: (
                                    <Text size="sm">
                                      Confirm action and generate a new scanner
                                    </Text>
                                  ),
                                  onConfirm: () => {
                                    generateScanner(item.id);
                                    closeAllModals();
                                  },
                                }),
                            })
                          }
                        >
                          Generate Scanner
                        </Button>

                        <Button
                          compact
                          variant="filled"
                          color="red"
                          sx={{ width: "150px", marginTop: "5px" }}
                          onClick={() => {
                            apiWithInterceptor.delete(`/session/${item.id}`);
                            setDelete(true);
                          }}
                        >
                          Remove Session
                        </Button>
                      </Card.Section>
                    </Grid.Col>
                  </Grid>
                </Card>
              </Grid.Col>
            );
          })
        ) : (
          <Grid.Col
            sx={{
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
            }}
            span={12}
          >
            <h1>No sessions available</h1>
          </Grid.Col>
        )}
      </Grid>
    </Box>
  );
}
